import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-full bg-[#0A0A0A] relative z-[1] pb-12">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button
          onClick={() => navigate(-1)}
          variant="ghost"
          className="mb-8 text-[#D4B483] hover:bg-[#1A1A1A]"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Tillbaka
        </Button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="font-playfair text-4xl font-bold text-[#EDEDED] mb-2">Integritetspolicy</h1>
          <p className="text-[#9A9AA2] text-sm mb-8">Senast uppdaterad: 28 juni 2026</p>
          <div className="text-[#D4D4D8] space-y-6 leading-relaxed">
            <p>
              Din integritet är viktig för oss på Bästa Biten. Denna integritetspolicy beskriver hur vi samlar in, använder och skyddar dina personuppgifter när du använder vår webbplats och våra tjänster.
            </p>
            <div className="bg-[#121212] border border-[#27272A] rounded-xl p-5 text-sm space-y-1">
              <p className="font-semibold text-[#EDEDED] mb-1">Personuppgiftsansvarig</p>
              <p>Bästa Biten</p>
              <p>Organisationsnummer: [ORG.NR]</p>
              <p>Adress: [POSTADRESS]</p>
              <p>Telefon: [TELEFON]</p>
              <p>Kontakt: via meddelandefunktionen på din profilsida (Min Profil → Kontakta oss)</p>
            </div>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">1. Information vi samlar in</h2>
            <p>
              Vi samlar in information som du tillhandahåller direkt till oss, till exempel när du skapar ett konto, gör en beställning eller kontaktar oss. Detta kan inkludera ditt namn, e-postadress, telefonnummer, leveransadress och betalningshistorik. 
              Observera att vi inte sparar några kortuppgifter eller betalningsinformation, då alla betalningar sker fysiskt på plats, per kort vid leverans eller avhämtning.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">2. Hur vi använder din information</h2>
            <p>
              Vi använder din information för att:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Hantera och leverera dina beställningar.</li>
              <li>Kommunicera med dig angående din order.</li>
              <li>Förbättra våra produkter och tjänster.</li>
              <li>Skicka viktig information som kvitton, tekniska meddelanden och uppdateringar.</li>
            </ul>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">3. Radering av konto och data</h2>
            <p>
              Du har rätt att när som helst begära radering av dina personuppgifter. Detta kan göras direkt via din profil under "Min Profil" genom att klicka på "Radera konto". Vid radering tar vi bort all din identifierbara information, med undantag för anonymiserad orderhistorik och information som vi är skyldiga enligt lag att behålla (t.ex. för bokföring).
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">4. Cookies</h2>
            <p>
              Vi använder cookies och liknande tekniker för att ge dig en bättre användarupplevelse. En cookie är en liten textfil som sparas på din enhet. Du kan läsa mer om detta i vår Cookie-banner och stänga av icke-nödvändiga cookies via din webbläsare.
            </p>
            <h2 className="text-xl font-bold text-[#EDEDED] mt-8 mb-4">5. Kontakta oss</h2>
            <p>
              Om du har frågor om denna integritetspolicy eller hur vi hanterar dina personuppgifter är du välkommen att kontakta oss. Enklast gör du det direkt på webbplatsen: logga in, gå till <span className="text-[#EDEDED] font-medium">Min Profil</span> och skriv ditt meddelande i rutan <span className="text-[#EDEDED] font-medium">"Kontakta oss"</span> längst ner på sidan — så återkommer vi till dig. Du kan även ringa oss på telefonnumret ovan.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
